import React from "react";

export default function ExportLog() {
  return (
    <div className="w-full min-h-80 flex flex-col">
      <div className="w-full min-h-80 flex flex-col justify-center items-center ">
        <h1>No Data</h1>
        <h1>No Data Export</h1>
      </div>
    </div>
  );
}
